import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CustomCircularProgress from "./UiComponents/CustomCircularProgress.js";
import { getInstructionsUrl } from "../instructionsDocument";

/**
 * Landing page for the "Document Review Process" link in assignment emails.
 *
 * Reached by following a link and then logging in, so there is no click left to
 * hang a window.open() off - the popup blocker would eat it. This tab was opened
 * by the email client though, so we just point it at the pdf: the reviewer ends
 * up with the manual in its own tab either way.
 */
export const InstructionsPage = () => {
  useEffect(() => {
    //ensure that download redirect is cleared when visiting this page
    localStorage.setItem("download_redirectUri", "");
  }, []);

  const [pdfUrl, setPdfUrl] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const currentUser = useSelector((state) => state.auth);

  useEffect(() => {
    getInstructionsUrl(currentUser.jwtIdToken.idToken)
      .then((url) => {
        setPdfUrl(url);
        //replace rather than assign so back returns to the site, not to this page
        window.location.replace(url);
      })
      .catch((error) => {
        console.error(error);
        setErrorMessage(
          "Unable to open the Document Review Process manual. Please try again in a few minutes."
        );
      });
  }, []);

  if (errorMessage) {
    return <div>{errorMessage}</div>;
  }

  return (
    <div style={{ display: "flex", justifyContent: "flex-start", gap: "1em" }}>
      <div style={{ position: "relative", width: "2em", height: "2em" }}>
        <CustomCircularProgress />
      </div>
      {pdfUrl ? (
        //only shown if the browser did not follow the redirect above
        <span>
          Opening the Document Review Process manual.{" "}
          <a href={pdfUrl}>Click here</a> if it does not open automatically.
        </span>
      ) : (
        <span>Loading</span>
      )}
    </div>
  );
};
